import { useDeleteQuestionnaire } from '@/api/assessor-questionnaire.hook'
import { CompanyProfile } from '@/gen/inventory/v1/company_service_pb'

import {
  ConfirmResult,
  useConfirmModal,
} from '@/components/lemmala-design-system/modal/use-confirm-modal'

type UseDeleteQuestionnaireModalProps = {
  questionnaireId: string
  questionnaireName: string
  companyName: CompanyProfile['name']
}

export const useDeleteQuestionnaireModal = ({
  questionnaireId,
  questionnaireName,
  companyName,
}: UseDeleteQuestionnaireModalProps) => {
  const { confirm } = useConfirmModal()
  const { mutateAsync: deleteQuestionnaire } = useDeleteQuestionnaire()

  const showDeleteQuestionnaireModal = async () => {
    const result = await confirm({
      variant: 'destructive',
      title: 'Delete Questionnaire',
      content: `Are you sure you want to delete the questionnaire "${questionnaireName}" sent to ${companyName}? This action will permanently remove the questionnaire and its answers, making them inaccessible.`,
    })
    if (result === ConfirmResult.CONFIRMED) await deleteQuestionnaire({ questionnaireId })
  }

  return {
    showDeleteQuestionnaireModal,
  }
}
